<template>
    <div class="upload-container">
        <el-button  icon="el-icon-upload" size="mini" plain type="primary"
                   @click=" dialogVisible=true"
        >
            上传图片
        </el-button>
        <el-dialog :visible.sync="dialogVisible" title="上传图片" width="30%">
            <el-form label-width="100px" :model="uploadForm" ref="uploadForm" :rules="rules">
                <el-form-item label="图片" style="margin-bottom: 20px" prop="url">
                    <el-image
                        style="width: 200px; height: 200px"
                        :src="uploadForm.url"
                        fit="contain">
                        <div slot="error" style="height: 200px;width: 200px;background:#efefef;display:flex;justify-content: center;align-items: center;font-size: 40px;color: #aaa;border-radius:10px;">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <div>
                        <el-button size="mini" plain type="primary" @click="click_file('addFile')" :loading="is_upload">{{uploadForm.url.length == 0?'上传图片':'更新图片'}}</el-button>
                        <span style="font-size: 12px;color: #aaa">
                            只能上传jpg,jpeg,png,gif的图片,最大不超过1MB
                        </span>
                        <input type="file" name="addFile" @change="file_change($event,'add')" ref="addFile" style="display:none;">
                    </div>
                </el-form-item>
                <el-form-item label="图片宽度"  style="margin-bottom: 20px">
                    <el-input placeholder="支持 px,% 等单位" v-model="uploadForm.width"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain @click="addImg">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
// import { getToken } from 'api/qiniu'

import {deepClone} from '@/utils'

export default {
    name: 'EditorSlideUpload',
    props: {
        color: {
            type: String,
            default: '#1890ff'
        }
    },
    data() {
        return {
            dialogVisible: false,
            listObj: {},
            fileList: [],
            is_upload:false,
            uploadForm:{
                url:"",
                width:"100%",
                height:"auto"
            },
            rules:{
                url:[
                    { required: true, message: '请上传一张图片', trigger: 'blur' },
                ]
            }
        }
    },
    methods: {
        addImg(){
            this.$refs["uploadForm"].validate(valid=>{
                if(!valid) return false;
                this.$emit("uploadOk",deepClone(this.uploadForm));
                this.$message.success("插入图片成功!");
                this.dialogVisible = false;
                this.uploadForm = {
                    url:"",
                    width:"100%",
                    height:"auto"
                };
            });
        },
        click_file(){
            this.$refs["addFile"].click();
        },
        file_change(e,type){
            let file = e.target.files[0];
            this.is_upload = true;
            this.$store.dispatch("upload/uploadImg",{file:file}).then(res=>{
                e.target.value = "";
                this.is_upload = false;
                this.uploadForm.url = res.url;
                this.$message.success("上传图片成功!");
                this.is_upload = false;
            }).catch(err=>{
                this.is_upload = false;
                e.target.value = "";
                this.$message.warning(err.msg);
            });
        },
        checkAllSuccess() {
            return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess)
        },
        handleSubmit() {
            const arr = Object.keys(this.listObj).map(v => this.listObj[v])
            if (!this.checkAllSuccess()) {
                this.$message('Please wait for all images to be uploaded successfully. If there is a network problem, please refresh the page and upload again!')
                return
            }
            this.$emit('successCBK', arr)
            this.listObj = {}
            this.fileList = []
            this.dialogVisible = false
        },
        handleSuccess(response, file) {
            const uid = file.uid
            const objKeyArr = Object.keys(this.listObj)
            for (let i = 0, len = objKeyArr.length; i < len; i++) {
                if (this.listObj[objKeyArr[i]].uid === uid) {
                    this.listObj[objKeyArr[i]].url = response.files.file
                    this.listObj[objKeyArr[i]].hasSuccess = true
                    return
                }
            }
        },
        handleRemove(file) {
            const uid = file.uid
            const objKeyArr = Object.keys(this.listObj)
            for (let i = 0, len = objKeyArr.length; i < len; i++) {
                if (this.listObj[objKeyArr[i]].uid === uid) {
                    delete this.listObj[objKeyArr[i]]
                    return
                }
            }
        },
        beforeUpload(file) {
            const _self = this
            const _URL = window.URL || window.webkitURL
            const fileName = file.uid
            this.listObj[fileName] = {}
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.src = _URL.createObjectURL(file)
                img.onload = function() {
                    _self.listObj[fileName] = {
                        hasSuccess: false,
                        uid: file.uid,
                        width: this.width,
                        height: this.height
                    }
                }
                resolve(true)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.editor-slide-upload {
    margin-bottom: 20px;

    ::v-deep .el-upload--picture-card {
        width: 100%;
    }
}
</style>
